import React from "react";

import { ChapterLogo } from "~/common/assets";
import { AgreeToTermsAndPolicy } from "~/common/components";
import AuthenticationLayout from "~/common/components/layouts/AuthenticationLayout";
import { EXTERNAL_URL } from "~/common/utils/externalURL";
import LogInForm from "~/patients/components/LogInForm";
import { patientWelcomeText } from "../constants/constants";

export const Login = () => {
  return (
    <AuthenticationLayout
      welcomeText={patientWelcomeText}
      className="h-1/2 flex-1 justify-between overflow-y-auto md:pb-8 xl:justify-start xl:gap-32"
      hideHeaderMobile
    >
      <hr /> {/* <hr /> present for flex layout purposes */}
      <div className="flex w-full flex-col items-center gap-8">
        <img className="xl:hidden" src={ChapterLogo} alt="Chapter Logo" />
        <LogInForm />
        <AgreeToTermsAndPolicy termsUrl={EXTERNAL_URL.TERMS_PATIENT} />
      </div>
    </AuthenticationLayout>
  );
};
